<select (change)="changeLanguage($event.target.value)" aria-label="SelectLanguage" tabindex="0">
    <option *ngFor="let lang of translatedLanguages" [value]="lang.code" [selected]="lang.code === translate.currentLang">
        {{ lang.name }}
    </option>
</select>
